import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

function AvailableBedViewDetails() {
  const location = useLocation();
  const navigate = useNavigate();

  const bed = location.state || {};
  const pgName = bed.pgName || "My PG";

  // ================= BOOK NAVIGATION =================
  const handleBook = () => {
    navigate("/UserCompleteBookingForm", {
      state: {
        ...bed,
        pgName: pgName,
      },
    });
  };

  return (
    <div style={styles.container}>
      {/* HEADER */}
      <div style={styles.header}>
        <h1 style={styles.title}>🛏 Bed Details</h1>
        <p style={styles.subTitle}>{pgName}</p>
      </div>

      {/* CARD */}
      <div style={styles.card}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/2972/2972449.png"
          alt="bed"
          style={styles.image}
        />

        <div style={styles.info}>
          <h2 style={styles.bedName}>{bed.bedName}</h2>

          <p style={styles.text}>
            🏢 Floor: <b>{bed.floorName}</b>
          </p>

          <p style={styles.text}>
            🚪 Room: <b>{bed.roomName}</b>
          </p>

          <p style={styles.text}>
            🆔 Bed ID: <b>{bed.bedId}</b>
          </p>

          <p style={styles.text}>
            🆔 Bed Name: <b>{bed.bedName}</b>
          </p>

          <p style={styles.price}>💰 ₹ {bed.bedCost}</p>

          {/* ✅ BOOK BUTTON */}
          <button style={styles.button} onClick={handleBook}>
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default AvailableBedViewDetails;

// ================= STYLES =================
const styles = {
  container: {
    minHeight: "100vh",
    padding: "25px",
    background: "linear-gradient(135deg,#e0f2fe,#f8fafc,#eef2ff)",
    fontFamily: "Segoe UI",
  },

  header: {
    textAlign: "center",
    marginBottom: "25px",
  },

  title: {
    fontSize: "32px",
    fontWeight: "800",
    color: "#0f172a",
  },

  subTitle: {
    fontSize: "16px",
    color: "#475569",
    fontWeight: "600",
  },

  card: {
    maxWidth: "420px",
    margin: "0 auto",
    background: "#fff",
    borderRadius: "18px",
    padding: "20px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    textAlign: "center",
  },

  image: {
    width: "100%",
    height: "180px",
    objectFit: "contain",
    marginBottom: "10px",
  },

  info: {
    textAlign: "left",
  },

  bedName: {
    fontSize: "22px",
    fontWeight: "800",
    marginBottom: "10px",
    color: "#1e293b",
  },

  text: {
    fontSize: "15px",
    margin: "6px 0",
    color: "#475569",
  },

  price: {
    fontSize: "20px",
    fontWeight: "900",
    color: "#16a34a",
    marginTop: "10px",
  },

  button: {
    marginTop: "15px",
    width: "100%",
    padding: "12px",
    border: "none",
    borderRadius: "10px",
    background: "linear-gradient(45deg,#2563eb,#06b6d4)",
    color: "#fff",
    fontWeight: "700",
    cursor: "pointer",
  },
};
